import { createStore } from "vuex";
import userStore from '@/store/modules/userStore';
import cmpStore from '@/store/modules/cmpStore';

export default createStore({
  modules: {
    userStore,
    cmpStore
  },
});